import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import BluecoinsUsage from '../../components/Bluecoins/Usage';
import { PERMISSION_BLUECOINS } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

// Optional pre-filter: opened from the bluecoins list row actions with ?uuid=<uuid>
const bluecoinsUsageSearchSchema = z.object({
  uuid: z.coerce.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/bluecoins/usage')({
  validateSearch: bluecoinsUsageSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_BLUECOINS, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'table_list.tabs.bluecoin.usage',
        suffix: 'menu.bluecoins',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: BluecoinsUsageRoute,
});

function BluecoinsUsageRoute() {
  return <BluecoinsUsage />;
}
